/**
 * Utility for generating dynamic imgix URLs using RemoteImage configuration
 */

type Options = {
  auto?: string;
  format?: string;
  w?: number;
  h?: number;
  dpr?: number;
  fit?: string;
  q?: number;
  [key: string]: string | number | undefined;
};

/**
 * Builds an URL query string from options
 */
function buildQueryString(options: Options): string {
  const params = new URLSearchParams();

  Object.entries(options).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });

  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

/**
 * Generate remote image URL using the host from backend or default one
 * @param path - The path to the image (e.g., "gen/ai-loader.gif")
 * @param options - Optional parameters
 * @returns The complete imgix URL
 */
export function remoteImageStaticUrl(path: string, options: Options = {}): string {
  const host = window.jiffy?.remoteImageHost; // provided in frontend_routes
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  const queryString = buildQueryString(options);
  return `${host}/${cleanPath}${queryString}`;
}
